import React, { useEffect, useState } from "react";
import "./App.css";

function App() {
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vQgu-VyJSovQtJXG2rWIDZGax22LXC0fStEnIjOT-m31FTdhrKOkD3RQ0-U6sh_1fjITfK-Gtf0IM4X/pub?gid=0&single=true&output=csv");
        const text = await response.text();
        const rows = text.trim().split("\n").map((line) => line.split(","));
        const lastUpdated = new Date().toLocaleTimeString();

        setData(rows.slice(1)); // skip header
        setLastUpdated(lastUpdated);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="dashboard">
      <h1>🧦Pairs Packing Dashboard</h1>
      <p className="updated">Last updated at: {lastUpdated}</p>
      <table>
        <thead>
          <tr>
            <th>Hour</th>
            <th>Sam</th>
            <th>Buse</th>
            <th>Jaffa</th>
            <th>Morgan</th>
            <th>Kate</th>
            <th>Mitch</th>
            <th>Susan</th>
            <th>Marcin</th>
            <th>Gabriela</th>
            <th>Sarah</th>
            <th>Team Total</th>
            <th>Orders Remaining</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {row.map((cell, cIdx) => (
                <td key={cIdx}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default App;
